import React from 'react'

const clamp = (val, min, max) => Math.min(max, Math.max(min, val))

const ProgressBar = function (props) {
  const {
    value,
    max,
    label,
    showLabel,
    heightClass,
    trackClassName,
    barClassName,
    className,
    roundedClass,
  } = props

  const safeMax = Number(max || 100) || 100
  const safeValue = Number(value || 0) || 0
  const percent = safeMax <= 0 ? 0 : (safeValue / safeMax) * 100
  const percentClamped = clamp(percent, 0, 100)

  return (
    <div className={className || ''}>
      {(showLabel || label) && (
        <div className="flex items-center justify-between mb-2">
          <p className="text-xs font-semibold text-base-gray-text-secondary">
            {label || 'Progress'}
          </p>
          <p className="text-xs font-semibold text-base-gray-text-secondary">
            {Math.round(percentClamped)}%
          </p>
        </div>
      )}
      <div
        className={[
          'w-full bg-base-gray-50',
          heightClass || 'h-1.5',
          roundedClass || 'rounded-full',
          trackClassName || '',
        ].join(' ')}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={safeMax}
        aria-valuenow={safeValue}
      >
        <div
          className={[
            'h-full bg-base-green-main transition-all duration-300 ease-out',
            roundedClass || 'rounded-full',
            barClassName || '',
          ].join(' ')}
          style={{ width: `${percentClamped}%` }}
        />
      </div>
    </div>
  )
}

ProgressBar.defaultProps = {
  value: 0,
  max: 100,
  showLabel: false,
  heightClass: 'h-1.5',
  roundedClass: 'rounded-full',
}

export default ProgressBar

